import { Time } from '@funkey/shared';
import type { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';
import { v4 as uuid } from 'uuid';

export namespace Visitor {
    export namespace Cookie {
        export const KEY = 'visitor-id';

        export function get(jar: ReadonlyRequestCookies) {
            return jar.get(Cookie.KEY)?.value || null;
        }

        /** PostHog's `distinct_id` is bootstrapped from this cookie, so its lifetime caps how
         * long a buyer stays the same "person". Letting it lapse creates a fresh person whose
         * `$initial_*` (first-click) properties are re-seeded from that visit — which silently
         * collapses first-click attribution onto the last click.
         *
         * Four months covers the typical teambuilding orientation-to-booking window. Note the
         * middleware only sets this cookie when absent, so it is an absolute expiry from the
         * first visit, not a sliding one. */
        export const MAX_AGE = Time.seconds({ days: 120 });

        export const create = (value: string = uuid()) => ({
            name: KEY,
            value,
            maxAge: MAX_AGE,
        });
    }
}
